import React, { useState, useEffect, useRef } from 'react'
import { Row, Col, Form, Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Card from '../../../components/Card'
import { API_ACL_SETTING_LIST, API_ACL_SETTING_DELETE } from '../../../service/url';
import { getApiCall, deleteApiCallWithHeader } from '../../../service/httpCall';
import { DataTable } from 'primereact/datatable';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import RenderDeleteModal from '../../../components/partials/components/delete-modal';
import ToastNotification from '../../../components/Toast';
import { ROUTES, MODULE_ACL, USER_ROLES } from '../../../utilities/constant';
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import Loader from '../../../components/partials/components/loader';
import { useNavigate } from "react-router-dom";
import { useAuth, errorCheck } from '../auth/auth-utils';
import { EditIcon, DeleteIcon } from '../../../components/setting/elements';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import "../../../assets/custom/css/custom.css";
import { postApiCall } from "../../../service/httpCall";
import exportData from '../../../utilities/export';
import { getUser } from "../../../utilities/setting";
import { toast } from "react-toastify";
import { FaEye, FaCheck, FaTimes } from "react-icons/fa";


//theme
import 'primereact/resources/themes/lara-light-indigo/theme.css';
//core
import 'primereact/resources/primereact.min.css';

const ACLSettingList = () => {
   const navigate = useNavigate();
   const { checkAuth } = useAuth();
   const [aclSettingList, setAClSettingList] = useState([]);
   const [filters, setFilters] = useState({
      name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
   });
   const [enableDeleteModal, setEnableDeleteModal] = useState(false);
   const [confirmDelete, setConfirmDelete] = useState(false);
   const [deleteACLId, setDeleteACLId] = useState(undefined);
   const [showToast, setShowToast] = useState(false);
   const [toastProps, setToastProps] = useState(null);
   const [loading, setLoading] = useState(false);
   const [selectedAcl, setSelectedAcl] = useState([]);
   const [isMultiDelete, setIsMultiDelete] = useState(false);
   const [buttonDisable, setButtonDisable] = useState(false);

   const [searchValue, setSearchValue] = useState(null);
   const [originalDataList, setOriginalDataList] = useState([]);
   const [loggedInUserACL, setLoggedInUserACL] = useState({})
   const [isSuperAdmin, setIsSuperadmin] = useState(false)
   const [showViewModal, setShowViewModal] = useState(false);
   const [selectedAclForView, setSelectedAclForView] = useState(null);

   const handleExport = async () => {
   try {
      setButtonDisable(true);

      exportToCSV({
         fileName: "acl-settings",
         data: aclSettingList,
         columns: [
            {
               header: "ACL Name",
               accessor: "acl_name"
            },
            {
               header: "ACL Allocated",
               accessor: (row) =>
                  row.is_allocated
                     ? "Allocated"
                     : "Not Allocated"
            },
            {
               header: "Created Date",
               accessor: (row) =>
                  new Date(row.created_at).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            },
            {
               header: "Updated Date",
               accessor: (row) =>
                  new Date(row.updated_at).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            }
         ]
      });

   } finally {
      setButtonDisable(false);
   }
};

   const handleCheckboxToggle = (aclId) => {
      const isSelected = selectedAcl.includes(aclId);
      setSelectedAcl(isSelected
         ? selectedAcl.filter(id => id !== aclId)
         : [...selectedAcl, aclId]);
   };

   const handleMultiDelete = () => {
      setIsMultiDelete(true);
      setEnableDeleteModal(true);
   };

   const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});
   
     useEffect(() => {
      const user = getUser();
         if (user) {
           if (user?.acl_settings) {    
             setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
           }
         }
     }, []);


   // useEffect( () => {

   //    if(toastProps){
   //       setShowToast(true);
   //    }

   // }, [toastProps]);

   useEffect(() => {
      setLoading(true);
      const user = getUser();
         if (user.role === USER_ROLES.SUPERADMIN) {
            setIsSuperadmin(true);
         }
         if (user?.acl_settings) {
            setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
         }
      getApiCall(API_ACL_SETTING_LIST)
         .then(onAClSettingListSuccess)
         .catch(onError)
         .finally(() => setLoading(false));

   }, []);


   function onAClSettingListSuccess(resp) {
      const updatedList = resp.map((val, idx) => {
         val['key'] = idx + 1;
         // val['actions'] = RenderActionComponent(val.id);
         val['created_at'] = new Date(val['created_at']).toGMTString();
         return val;
      });
      setAClSettingList(updatedList);
      setOriginalDataList(updatedList);
   }

   useEffect(() => {
      if (searchValue) {
         const filtered = originalDataList.filter((data) =>
            data.acl_name.toLowerCase().includes(searchValue.trim().toLowerCase())
         );
         setAClSettingList(filtered);
      } else {
         setAClSettingList(originalDataList);
      }
   }, [searchValue, originalDataList]);

   async function handleDeleteAclSetting(id) {
      checkAuth(setToastProps, setShowToast)
      setIsMultiDelete(false);
      setEnableDeleteModal(true);
      setDeleteACLId(id);
   }

   const handleSelectAll = () => {
      const selectableAclIds = aclSettingList
         .filter((acl) => isSuperAdmin || !acl.default_for_role)
         .map((acl) => acl.id);

      if (selectedAcl.length === selectableAclIds.length) {
         setSelectedAcl([]);
      } else {
         setSelectedAcl(selectableAclIds);
      }
   };

   useEffect(() => {
      if (confirmDelete) {
         if (isMultiDelete) {
            postApiCall(API_ACL_SETTING_DELETE, { aclIds: selectedAcl })
               .then(onDeleteSuccess)
               .catch(onDeleteFail);
         } else {
            postApiCall(API_ACL_SETTING_DELETE, { aclIds: [deleteACLId] })
               .then(onDeleteSuccess)
               .catch(onDeleteFail);
         }
      }
   }, [confirmDelete]);

   function onDeleteSuccess(resp) {
      //  setToastProps({ type: 'success', message: 'ACL Setting deleted successfully' });
      toast.success("ACL Setting deleted successfully");
      let updatedList;
      if (isMultiDelete) {
         updatedList = aclSettingList.filter(val => !selectedAcl.includes(val.id)).map((val, key) => {
            val['key'] = key + 1;
            return val;
         });
         setSelectedAcl([]);
      } else {
         updatedList = aclSettingList.filter(val => val.id != deleteACLId).map((val, key) => {
            val['key'] = key + 1;
            return val;
         });
      }
      setLoading(true);
      getApiCall(API_ACL_SETTING_LIST)
         .then(onAClSettingListSuccess)
         .catch(onError)
         .finally(() => setLoading(false));
      setAClSettingList(updatedList);
      setEnableDeleteModal(false);
      setDeleteACLId(undefined);
      setConfirmDelete(false);
   }

   function onDeleteFail(err) {
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
         errorCheck(err, navigate, setToastProps, setShowToast)
      } else {
         //  setToastProps({ type: 'danger', message: `Unable to delete acl setting: ${err}` });
         toast.error(`Unable to delete acl setting: ${err}`);
      }
   }

   const canRead = hasPermission(
        moduleOperationsForReadPermissionCheck,
        "ACL Setting List",
        "read",
      );
    
      if (Object.keys(moduleOperationsForReadPermissionCheck).length > 0 && !canRead) {
        return (
          <div
            className="text-center p-4"
            style={{
              marginTop: "50px",
              marginBottom: "50px",
              fontSize: "16px",
            }}
          >
            No read permission found in assigned ACL
          </div>
        );
      }


   if (loading) {
      return <Loader />
   }


   const RenderActionComponent = ({ id, rowData }) => {
      const aclSettingEditRoute = ROUTES.ACL_SETTING.EDIT.replace(':id', id);
      const isDefaultAcl = Boolean(rowData.default_for_role);
      const canManageDefaultAcl = isSuperAdmin || !isDefaultAcl;

      return (
         <div className="flex align-items-center list-user-action">
            <button
               type="button"
               className="btn btn-sm btn-icon"
               title="View"
               onClick={() => {
                  setSelectedAclForView(rowData);
                  setShowViewModal(true);
               }}
               style={{
                  marginRight: "6px",
                  backgroundColor: "#7393B3",
                  borderColor: "#7393B3",
                  color: "#ffffff",
               }}
            >
               <span className="btn-inner">
                  <FaEye size={14} />
               </span>
            </button>

            {canManageDefaultAcl &&
               (isSuperAdmin || loggedInUserACL[MODULE_ACL.ACL_SETTING_LIST]?.edit) && (
                  <EditIcon linkTo={`/${aclSettingEditRoute}`} />
               )}

            {' '}

            {canManageDefaultAcl &&
               (isSuperAdmin || loggedInUserACL?.[MODULE_ACL.ACL_SETTING_LIST]?.delete) &&
               selectedAcl.length === 0 &&
               !rowData.is_allocated && (
                  <DeleteIcon
                     handleCallback={() => handleDeleteAclSetting(id)}
                  />
               )
            }

            {' '}
         </div>
      );
   };
   const dropdownItemTemplate = (option) => {
      return <span>{option}</span>;
   }



   function onError(err) {
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
         errorCheck(err, navigate, setToastProps, setShowToast)
      } else {
         console.log(err)
      }
   }

   const handleCreateButtonClick = () => {
      navigate(`/${ROUTES.ACL_SETTING.CREATE}`);
   }


   const rowClassName = (data) => {
      return {
         'highlighted-row': selectedAcl.includes(data.id)
      };
   }

   const actionBodyTemplate = (rowData) => {
      return <RenderActionComponent id={rowData.id} rowData={rowData} />;
   };

   const parseModuleOperations = (moduleOperations) => {
      if (!moduleOperations) return {};
      if (typeof moduleOperations === "object") return moduleOperations;
      try {
         return JSON.parse(moduleOperations);
      } catch (error) {
         return {};
      }
   };

   const renderPermission = (value) => (
      <span
         style={{
            color: value ? "green" : "red",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            fontSize: "14px",
         }}
      >
         {value ? <FaCheck /> : <FaTimes />}
      </span>
   );

   const selectedAclOperations = parseModuleOperations(selectedAclForView?.module_operations);
   const operationRows = Object.keys(selectedAclOperations).sort((a, b) => a.localeCompare(b));

   return (
      <>
         <div>
            <Row>
               <Col sm="12">
                  <Card>
                     <Card.Header className="d-block justify-content-between">
                        <div className="header-title">
                           <h4 className="card-title">ACL Setting List</h4>
                           {/* <RenderUserAccessRolesList activeUserAccessRole={activeUserAccessRole} userAccessRoles={userAccessRoles} setActiveUserAccessRole={setActiveUserAccessRole} /> */}
                        </div>
                        {(isSuperAdmin || loggedInUserACL[MODULE_ACL.ACL_SETTING_LIST]?.add) && (
                           <button className="btn btn-primary ml-auto" onClick={handleCreateButtonClick}>Create ACL Setting</button>
                        )}
                     </Card.Header>
                     <Card.Body className="px-0">

                        <div className="table-responsive border-bottom my-3">
                           <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "flex-start" }}>
                              {((isSuperAdmin || loggedInUserACL?.[MODULE_ACL.ACL_SETTING_LIST]?.delete)) && (
                                 <Button
                                    label="Delete Selected"
                                    onClick={handleMultiDelete}
                                    className="p-button-danger p-button-sm"
                                    style={{ marginBottom: '10px', marginLeft: '10px' }}
                                    disabled={selectedAcl.length === 0}
                                 />
                              )}
                              {aclSettingList.length > 0 &&
                                 <Button
                                    label="Export Data"
                                    onClick={handleExport}
                                    className="p-button-active p-button-sm"
                                    style={{ marginBottom: '10px', marginLeft: '10px' }}
                                    disabled={buttonDisable}
                                 >
                                    &nbsp;
                                    {buttonDisable && (
                                       <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                                    )}
                                 </Button>
                              }

                              <Form.Group style={{ height: "45px" }}>
                                 <Form.Control
                                    style={{ height: "50px", marginLeft: "10px", border: "1px solid #ced4da", fontSize: "15px", height: "45px" }}
                                    placeholder='Search by Name...'
                                    type="text"
                                    maxLength={100}
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                    required
                                 />
                              </Form.Group>
                           </div>
                           <div className="scroll-container">
                              <DataTable value={aclSettingList} tableStyle={{ minWidth: '50rem' }} filters={filters} paginator rows={8} rowClassName={rowClassName}>
                                 <Column
                                    header={<Checkbox
                                       checked={selectedAcl.length === aclSettingList.filter((acl) => isSuperAdmin || !acl.default_for_role).length && aclSettingList.filter((acl) => isSuperAdmin || !acl.default_for_role).length > 0}
                                       onChange={handleSelectAll}
                                    />}
                                    headerStyle={{ width: '3rem' }}
                                    body={(rowData) => (
                                       <Checkbox
                                          checked={selectedAcl.includes(rowData.id)}
                                          onChange={() => handleCheckboxToggle(rowData.id)}
                                          disabled={!isSuperAdmin && Boolean(rowData.default_for_role)}
                                       />
                                    )}
                                 />
                                 <Column field="acl_name" filterField="ACL Name" header="ACL Name"></Column>
                                 <Column
                                    field="is_allocated"
                                    header="ACL Allocated"
                                    body={(rowData) => (
                                       <span style={{ color: rowData.is_allocated ? "green" : "red", fontWeight: "500" }}>
                                          {rowData.is_allocated ? "Allocated" : "Not Allocated"}
                                       </span>
                                    )}
                                 ></Column>
                                 <Column field="created_at" header="Created Date" body={(rowData) =>
                                    new Date(rowData.created_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                                 <Column field="updated_at" header="Updated Date" body={(rowData) =>
                                    new Date(rowData.updated_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                                 <Column header="Action" body={actionBodyTemplate} />
                              </DataTable>
                           </div>
                        </div>

                     </Card.Body>
                  </Card>
               </Col>
            </Row>
         </div>

         <RenderDeleteModal
            show={enableDeleteModal}
            setShow={setEnableDeleteModal}
            setConfirmDelete={setConfirmDelete}
            isMultiDelete={isMultiDelete}
            clearSelectedData={() => setSelectedAcl([])}
         />

         <Modal show={showViewModal} onHide={() => setShowViewModal(false)} size="xl" centered>
            <Modal.Header closeButton>
               <Modal.Title>ACL Permission View</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <div style={{ marginBottom: "12px" }}>
                  <strong>ACL Name:</strong> {selectedAclForView?.acl_name || "-"}
               </div>
               {selectedAclForView?.default_for_role && (
                  <div style={{ marginBottom: "12px" }}>
                     <strong>Default For Role:</strong> {selectedAclForView.default_for_role}
                  </div>
               )}

               <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                     <thead>
                        <tr>
                           <th>Module</th>
                           <th style={{ textAlign: "center" }}>Read</th>
                           <th style={{ textAlign: "center" }}>Add</th>
                           <th style={{ textAlign: "center" }}>Edit</th>
                           <th style={{ textAlign: "center" }}>Delete</th>
                           <th style={{ textAlign: "center" }}>View</th>
                        </tr>
                     </thead>
                     <tbody>
                        {operationRows.length === 0 ? (
                           <tr>
                              <td colSpan="6" style={{ textAlign: "center" }}>
                                 No module operations found.
                              </td>
                           </tr>
                        ) : (
                           operationRows
                              // Filter logic: Check if at least one permission is true
                              .filter((moduleName) => {
                                 const ops = selectedAclOperations[moduleName] || {};
                                 return (
                                    ops.read ||
                                    ops.add ||
                                    ops.edit ||
                                    ops.delete ||
                                    ops.view_permission
                                 );
                              }).map((moduleName) => {
                                 const ops = selectedAclOperations[moduleName] || {};
                                 return (
                                    <tr key={moduleName}>
                                       <td>{moduleName}</td>
                                       <td style={{ textAlign: "center" }}>{renderPermission(ops.read)}</td>
                                       <td style={{ textAlign: "center" }}>{renderPermission(ops.add)}</td>
                                       <td style={{ textAlign: "center" }}>{renderPermission(ops.edit)}</td>
                                       <td style={{ textAlign: "center" }}>{renderPermission(ops.delete)}</td>
                                       <td style={{ textAlign: "center" }}>{renderPermission(ops.view_permission)}</td>
                                    </tr>
                                 );
                              })
                        )}
                     </tbody>
                  </table>
               </div>
            </Modal.Body>
         </Modal>

         {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

      </>
   )

}

export default ACLSettingList;